// Sample card from Airbnb
import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom"
import classes from "../styles.module.css"; 
import { useParams } from "react-router-dom";
import { BsFillFileEarmarkPdfFill } from "react-icons/bs"
import APIConfig from "../../../api/APIConfig";

import {
    Box,
    Center,
    Icon,
    Text,
    Button,
    VStack,
    HStack,
} from '@chakra-ui/react';

const LihatDokumen = (props) => {
    const [fileInfo2, setFileInfo2] = useState([]);
    const [urlDokumen, setUrlDokumen] = useState('');


    const { id } = useParams();

    const getCV = async() => {
        const response = await APIConfig.get(`/v1/cv/file/${id}`);
        const result = await response.data;
        setFileInfo2(result);
    };

    const getUrlDokumen = async() => {
        const response = await APIConfig.get(`/v1/urlDokumen/${id}`);
        const result = await response.data;
        setUrlDokumen(result.urlDokumen);
    };

    useEffect(() => {
        getCV();
        getUrlDokumen();
    }, []);

    return (
        <div>
        <Center py={6}>
        <VStack align='stretch' fontFamily={'Inter'}>
            <Box
                m='10px'
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                justifyContent='left'
                rounded={'2xl'}
                p={6}
                overflow={'hidden'}>
                <VStack 
                spacing={'50px'}
                align='stretch'
                >
                    <Text
                        pt={5}
                        paddingBottom={7}
                        color={'gray.900'}
                        fontWeight={650}
                        fontSize={'3xl'}>
                        Dokumen Peserta
                    </Text>
                    <div>
                        <h3 className={classes.h} >Curriculum Vitae</h3>
                        <div>
                            <HStack pt={5} pb={5}>
                                <Icon mr="5px" fontSize={'xl'} as={BsFillFileEarmarkPdfFill} />
                                <a href={fileInfo2.url} style={{marginRight: '30px'}}>
                                    <p className={classes.p}>{fileInfo2.name}</p>
                                </a>
                            </HStack>
                        </div>
                        <br></br><br></br>
                        <h3 className={classes.h} >URL Dokumen Tambahan</h3>
                        <div>
                            <HStack pt={5} pb={5}>
                                <a href={urlDokumen} style={{marginRight: '30px'}}>
                                    <p className={classes.p}>{urlDokumen}</p>
                                </a>
                            </HStack>
                        </div>
                    </div>

                </VStack>
                <Center pt={6}>
                    <Link to={`/peserta/dokumen/edit/${id}`}>
                        <Button p={6} w='100%' rounded={'xl'} colorScheme='purple' variant='solid'>
                            Edit Dokumen
                        </Button>
                    </Link>
                    
                </Center>
            </Box>
        </VStack>
        </Center>
        </div>
      );
  }

export default LihatDokumen;